module.exports = __webpack_public_path__ + "static/media/attachment.b3e9f75c.svg";